import React from 'react'

interface LayoutContainerProps {
  id?: string
  heading?: string
  headerComponent?: React.ReactNode
  description?: string
  children: React.ReactNode
  customClass?: string
}

const LayoutContainer: React.FC<LayoutContainerProps> = ({
  id,
  heading,
  description,
  children,
  headerComponent,
  customClass
}) => (
  <div
    id={id}
    className={`flex flex-col gap-2 p-4 bg-white border rounded border-gray-light ${customClass || ''}`}
    data-track-id={id ? `layout-container-${id}` : 'layout-container'}
  >
    {(heading || description || headerComponent) && (
      <div className='flex flex-col gap-0.5 pb-2'>
        {headerComponent && <div>{headerComponent}</div>}
        {heading && <h2 className='font-medium text-carbon text-base'>{heading}</h2>}
        {description && <p className='text-sm text-gray-dark'>{description}</p>}
      </div>
    )}
    {children}
  </div>
)

export default LayoutContainer
